import React from "react";
import { Tooltip } from "@mui/material";
import { FiUsers } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../hooks";
import { useWeb3Auth } from "../../../hooks/useWeb3Auth";
import BtoCMessage from "../../BtoCMessage";
import IconMenuList from "../../IconMenuList";
import WhiteBoardButton from "../../WhiteBoardButton";
import "./index.css";
import MemberCardActionButton from "../../MemberCardAction/MemberCardActionButton";
import SmallAppsButton from "../../SmallAppsButton";
import { useWhiteboardRoom } from "../../../hooks/useWhiteboardRoom";

const HeaderBar: React.FC = () => {
  const { t } = useTranslation();
  const { numUsers } = useAppSelector((state) => state.whiteboard);
  const { logined, isProticoAuthenticated } = useWeb3Auth();
  const { isPremium, gameCenterDappEnable } = useWhiteboardRoom();


  return (
    <div className="header-bar-actions">
      {logined && (
        <>
          {/* Hide to test if it will increase/decrease engagement, 2024 Sep
          <div className="incall-info">
            <Tooltip
              title={t("FlashChat_Current_Users")}
              placement="bottom-start"
              arrow
              disableInteractive
            >
              <div
                className="members-text"
                style={{ marginLeft: isProticoAuthenticated ? "50px" : "50px" }}
              >
                <FiUsers size={13} style={{ marginRight: "3px" }} />
                {numUsers}
              </div>
            </Tooltip>
          </div>
          */}
          <MemberCardActionButton />
          {isPremium && gameCenterDappEnable && <SmallAppsButton/>}
          <WhiteBoardButton />
          <BtoCMessage />
        </>
      )}
      <IconMenuList />
    </div>
  );
};

export default HeaderBar;
